import { FC } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { Redirect, useLocation } from "react-router-dom";

interface PrivateRouteProps {
  children: any;
}

const PrivateRoute: FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();
  const { inProgress } = useMsal();
  const location = useLocation();

  // Avoid route flicker while MSAL is still processing login/logout state.
  if (inProgress !== InteractionStatus.None) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <Redirect
        to={{
          pathname: "/quickpay",
          search: location.search,
        }}
      />
    );
  }

  return children;
};

export default PrivateRoute;
